<!--
	作者：582348093@qq.com
	时间：2018-07-05
	描述：品牌合作-联系我们
-->
<template>
	<section id="contactUs">
		<h1 class="titleText">联系我们</h1>
		<img src="../images/icon/line5.png" style="width: 100%;" />
		<article id="contactUsWarpper">
			<div style="flex: 1;">
				<textarea v-text="ContactUsText" readonly="readonly"></textarea>
			</div>
			<div style="flex: 0.3;">
				<img src="../images/icon/logo_black.png" />
			</div>
		</article>
		<h1 class="titleText">品牌合作</h1>
		<img src="../images/icon/line5.png" style="width: 100%;" />
		<article id="pphzWarpper">
			<div class="item" v-for="item in pPHZDataList">
				<a href="javascript:void(0)" target="_blank" >
					<img :src="item.imageUrl" style="width: 100%;height: 100%;cursor: default;" />
				</a>
			</div>
		</article>
	</section>
</template>

<script>
	export default {
		name: 'contactUs',
		data() {
			return {
				ContactUsText: '', // 联系我们
				pPHZDataList:[], // 品牌合作
			}
		},
		//监听
		watch: {},
		
		//页面完成以后
		mounted: function() {
			this.requestContactUs();
			this.requestPPHZ();
		},

		//事件处理
		methods: {
			// 请求联系我们
			requestContactUs:function(){
				this.request.get({
					url: '/about/text/3',
					params: {},
					callback: function(d) {
						this.ContactUsText=d.data.text;
						console.log('请求联系我们：', d);
					}.bind(this)
				})
			},
			// 请求品牌合作
			requestPPHZ:function(){
				this.request.get({
					url: '/about/brand-coop',
					params: {},
					callback: function(d) {
						this.pPHZDataList=d.data;
						console.log('请求品牌合作：', d);
					}.bind(this)
				})
			},
		},

	}
</script>

<style scoped>
	#contactUs {
		min-height: 600px;
		width: 60%;
		min-width: 1080px;
		margin: 0 auto;
	}
	.titleText{
		text-align: center;font-size: 30px;margin-bottom: 10px;
	}
	#contactUsWarpper{
		display: flex;margin-top: 30px;box-sizing: border-box;padding: 0 150px;
	}
	
	#contactUsWarpper textarea{
		width: 100%;height: 100%;resize: none;border: none;font-size: 20px;line-height: 40px;outline: none;background-color: rgba(0,0,0,0);
	}
	#pphzWarpper{
		display: flex;flex-wrap: wrap;margin-top: 30px;box-sizing: border-box;padding: 0 177px;width: 100%;min-width: 1141px;
	}
	#pphzWarpper .item{
		width: 232px;height: 120px;margin: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/components/contactUs.vue